import scroll from '@common/scroll/scroll'

/** A komponensre kattintáskor felkúszik. */
export default function onClick (): void {
  scroll.toTop()
}
